
let leftArrow, rightArrow, slider, itemSize, step, maxStep;

$(function(){
    slider = $('.home-best-sellers__row'),
    itemSize = slider.find('.product-item').outerWidth(),
    step = 1,
    maxStep = slider.find('.product-item').length,
    leftArrow = $('.home-best-sellers__left-arrow'),
    rightArrow = $('.home-best-sellers__right-arrow');

    initSlider();
    initAddtoCart();
    initUpdateCart();

    $('.product-cure-infos').on('click', function() {
        $('.cure-infos').toggle('600');
    })

    $('input[name="add"]').on('click', function() {
        $('.cure-selector').toggle();
    });
  
    $('#newsletter_submit').on('click', function(){
      let email = $('#newsletter_email');
          
      if(document.getElementById('newsletter_email').checkValidity() && email.val().length > 0) {
        $.get('https://eofidmzj5q14bf.m.pipedream.net', {'email': email.val()}).done(function() {
            $('.footer-form').hide();
            $('.success-message').show();
        });
        
      } else {
        
        alert('Merci de saisir une adresse email valide');
      }
    })
});


function initSlider()
{
    
    if($(window).width() < 992) {
        setSliderMobile();
        return;
    }

    maxStep -= 3;
        
    leftArrow.on('click', function(){
        moveSlider(-1);
    });

    rightArrow.on('click', function(){
        moveSlider(1);
    });

    moveSlider(0);
}

function setSliderMobile()
{
    leftArrow.css('display', 'none');
    rightArrow.css('display', 'none');

    let width = maxStep * itemSize + (maxStep - 1) * 25;

    $('.home-best-sellers__mask').on('scroll', function () {
        let left = $(this).scrollLeft();
        let progress = Math.floor((left / width) * 100);
        $('.home-best-sellers__mobile-progess').css('left', progress + '%');
    });
}

function moveSlider(increment)
{
    if(increment == 0) {
        step = 0;
    }

    step += increment;

    leftArrow.css('display', (step == 0) ? 'none' : 'flex');
    rightArrow.css('display', (step == maxStep) ? 'none' : 'flex');

    let move = -1 * (itemSize + 25) * step;

    slider.css('left', move);
}

function initAddtoCart()
{
    let inputsAdd = $('input[name="add"]');

    $('.product-intro-once-block').click(function(){
        inputsAdd[0].click();
        $('#selling_plan').val('');
    });

    $('.product-intro-recurrent').click(function(){
        inputsAdd[1].click();
        $('#selling_plan').val($(this).data('plan'));
    });

    $('.change-format').on('click', function(){
        // mettre a jour l'id du formulaire
        // changer le texte
        $('.w-slider-dot').eq(
            $(this).index() == 0 ? 1 : 0
        ).click();

        $('#variant_id').val(
            $(this).attr('data-id')
        );

        $('.change-format').each(function(){
            $(this).show();
        })

        let price = parseInt($(this).attr('data-price')),
            regular = price / 100,
            subPrice = Math.round(price * 0.8) / 100;

        $('#oneTimePrice').text(regular + ' €');

        $('#subPrice').text(subPrice + ' €');

        $(this).hide();
    });

    $('.product-slider-thumb').on('click', function(){
        $('.w-slider-dot').eq(
            $(this).index()
        ).click();
    });

    let urlParams = new URLSearchParams(window.location.search);

    if(urlParams.has('variant')) {
        let variant = urlParams.get('variant')
            variantOrder = 0;

        $('.product-slider-thumb').each(function() {
            if(variant == $(this).attr('data-id')) {
                $(this).click();
                variantOrder = $(this).index();
            }
        });

        if(variantOrder == 1) {
            $('.change-format').first().click();
        }
    }

}

function initUpdateCart()
{
    if($('.cart-row').length == 0) {
        return;
    }

    $('.qty_block').on('click', function(){
        $('#loader').css('display', 'flex');
        let  qtyText = $(this).siblings('.qty').first(),
            line = qtyText.data('id'),
            increment = $(this).data('increment'),
            qty = parseInt(qtyText.text());

        qty += increment;

        $.post('/cart/change.js', {
            line: line,
            quantity: qty,
        }).done(function() {
            location.reload();
        });
    });

    $('.cart-delete-col').on('click', function(){
        $('#loader').css('display', 'flex');
        let line = $(this).data('id');

        $.post('/cart/change.js', {
            line: line,
            quantity: 0,
        }).done(function() {
            location.reload();
        });
    });

    $('.edit-cure-btn').on('click', function(){
        $(this).find('.edit-cure-block').toggle();
    });

    $('.edit-cure-line').on('click', function(){
        $('#loader').css('display', 'flex');
        let line = $(this).parent().data('line'),
            id = $(this).parent().data('id'),
            plan = $(this).data('plan');
        
        plan = plan == '' ? null : plan; 

        $.post('/cart/change.js', {
            line: line,
            quantity: 0,
        }).done(function() {
            $.post('/cart/add.js', {
                id: id,
                quantity: 1,
                selling_plan: plan
            }).done(function() {
                location.reload();
            });
        });
    });

    $('.cart-delivery-wrapper').on('click', function(){
        $('.cure-infos').show('300');
    });

    $(document).on("click", function(event){
        if(!$(event.target).closest(".edit-cure-wrapper").length){
            $(".edit-cure-block").hide();
        }
    });
}